module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/01_shape-sm-57c27ee0c53a7ecfcb35a7f087bd405a.png";